import React, { FC } from "react";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { useEnquiryDetailModel } from "./enquiryDetailModel";
import { RouterParamType } from "@/model/navModel";
import { IEnquiryTabEnum } from "../../enquiryTypes";
import { BaseDetail } from "./base";
import { RelevanceTask } from "./task";
import { SupplierPrice } from "./price";
import { Files } from "./files";

export const TabBar: FC<RouterParamType> = (detailsInfo) => {
    const { tabActive, setTabActive } = useEnquiryDetailModel(({ tabActive }) => [tabActive]);
    const isEdit = detailsInfo.mode === "edit";

    //防止保存是表单拿不到， 在下面渲染
    const RenderTabItem = () => {
        switch (tabActive) {
            // case IEnquiryTabEnum.BASE_DETAIL:
            //     return <BaseDetail {...detailsInfo}/>;
            case IEnquiryTabEnum.SUPPLIER_PRICE:
                return <SupplierPrice {...detailsInfo} />;
            case IEnquiryTabEnum.RELEVANCE_TASK:
                return <RelevanceTask {...detailsInfo} />;
            case IEnquiryTabEnum.FILES:
                return <Files {...detailsInfo} />;
            default:
                return <></>
        }
    }

    const classname = (type: IEnquiryTabEnum) => {
        return 'tab-item ' + (tabActive === type ? 'tab-active' : '')
    }
    const action = <>
        <Button
            className={classname(IEnquiryTabEnum.BASE_DETAIL)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IEnquiryTabEnum.BASE_DETAIL)}
        >询价单详情</Button>
        <Button
            hidden={!isEdit}
            className={classname(IEnquiryTabEnum.SUPPLIER_PRICE)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IEnquiryTabEnum.SUPPLIER_PRICE)}
        >供应商报价</Button>
        <Button
            hidden={!isEdit}
            className={classname(IEnquiryTabEnum.RELEVANCE_TASK)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IEnquiryTabEnum.RELEVANCE_TASK)}
        >关联单据</Button>
        <Button
            hidden={!isEdit}
            className={classname(IEnquiryTabEnum.FILES)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IEnquiryTabEnum.FILES)}
        >附件管理</Button>
    </>

    return (
        <>
            <YhBox
                style={{ paddingBottom: 0, marginBottom: "10px" }}
                action={action}
            />
            <div hidden={tabActive !== IEnquiryTabEnum.BASE_DETAIL}><BaseDetail {...detailsInfo} /></div>
            <RenderTabItem />
        </>
    )
}